export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-quote-c7e96459d09631c71f2773a21c65d79f.svg";